// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"acd999b0","967":"9cb7f86c","2639":"0150fa95","4083":"715fff23","4353":"c99a748c","4620":"715fff23","6254":"715fff23","7628":"715fff23"}[chunkId] + ".chunk.css";
};